import { SET_CUSTOM_FRAMEWORK_DETAILS } from "constants/customFrameworks/customFrameworksConst";

const initial_state = {
  customFrameworkDetails: null,
};

export default function reducer(state = initial_state, action) {
  switch (action.type) {
    case SET_CUSTOM_FRAMEWORK_DETAILS:
      return (state = { ...state, customFrameworkDetails: action.payload });

    default:
      return state;
  }
}
